import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";

function CommentSetting(props) {
  const [order, setOrder] = useState({});
  const [editUser, setEditUser] = useState({
    id: "",
    videos: "",
    livestream: "",
    episode: "",
    audios: "",
    approval_status: "",
  });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");

  // console.log(access_token)

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  // console.log(headers)

  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/comment-section/index`, {
        headers: headers,
      })
      .then((response) => {
        // console.log("api checks", response.data.comment_section);
        var result = response?.data?.comment_section;
        setOrder(result);
        setEditUser(result);
        // console.log('result', result)
        // console.log('orders', order);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleInput = (e) => {
    setEditUser({ ...editUser, [e.target.name]: e.target.value });
    if (e.target.checked === true) {
      setEditUser({ ...editUser, [e.target.name]: 1 });
    } else {
      setEditUser({ ...editUser, [e.target.name]: 0 });
    }
  };

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  const handleUpdate = async (e) => {
    e.preventDefault();
    const videos = Number.isNaN(parseInt(editUser?.videos, 10)) ? 0 : parseInt(editUser?.videos, 10);
    const livestream = Number.isNaN(parseInt(editUser?.livestream, 10)) ? 0 : parseInt(editUser?.livestream, 10);
    const episode = Number.isNaN(parseInt(editUser?.episode, 10)) ? 0 : parseInt(editUser?.episode, 10);
    const audios = Number.isNaN(parseInt(editUser?.audios, 10)) ? 0 : parseInt(editUser?.audios, 10);
    const approval_status = Number.isNaN(parseInt(editUser?.approval_status, 10)) ? 0 : parseInt(editUser?.approval_status, 10);

    const editInputvalue = {
      id: editUser?.id,
      videos: videos,
      livestream: livestream,
      episode: episode,
      audios: audios,
      approval_status: approval_status
    };

    setProcessing(true);
    setShowOverlay(true);

    let res = await fetch(
      `${process.env.REACT_APP_Baseurl}/admin/comment-section/update`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify(editInputvalue),
      }
    );
    let resjson = await res.json();

    if (resjson.status === true) {
      var resultapi = resjson;

      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      if (resultapi && resultapi.status === false) {
        var resultError = resultapi;
        props.setApiresponsealert(resultError);
        props.setShowalert(true);
        setProcessing(false);
        setShowOverlay(false);
      }
    }
  };

  return (
    <>
      <div className="m-0 p-0">
        <section className="section container-fluid pt-3">
          {/* <div className="col-lg-12 row py-3">
            <div className="col-6 col-sm-6 col-lg-6">
              <h3>Comment Section</h3>
            </div>
            <div className="col-6 col-sm-6 col-lg-6 text-end">
              <button onClick={handleUpdate} className="btn btn-primary">
                Save Comment
              </button>
            </div>
          </div> */}
          <AdminSaveHeader heading={"Comment Section"} saveText={"Save Settings"} saveMethod={handleUpdate} />

          <div className="iq-card">
            <div>{showOverlay && <Response_Processing />}</div>

            <div className="col-lg-12">
              <MessageHeading text={"Comment Options"} />
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Comment Approval Status"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'approval_status'} onChange={handleInput} checked={editUser?.approval_status === 1} />
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Enable Comment Section for Videos"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'videos'} checked={editUser?.videos === 1} onChange={handleInput} />
                </div>
              </div>

              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Enable Comment Section for LiveStream"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'livestream'} checked={editUser?.livestream === 1} onChange={handleInput} />
                </div>
              </div>

              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Enable Comment Section for Episode"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'episode'} checked={editUser?.episode === 1} onChange={handleInput} />
                </div>
              </div>

              <div className="d-flex justify-content-between mb-2 ">
                <div className="col-6 col-md-6 pe-2">
                  <MessageLabel text={"Enable Comment Section for Audios"} />
                </div>
                <div className="col-6 col-md-6 ps-2 text-end">
                  <AdminSwitch name={'audios'} checked={editUser?.audios === 1} onChange={handleInput} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default CommentSetting;
